<template>
  <div class="component-header-top">
    <div class="breadcrumb">
      <el-breadcrumb>
        <el-breadcrumb-item
          v-for="item in breadcrumb"
          :key="item.name"
          :to="{ name: item.name, params: {course_id : item.course_id, chapter_id : item.chapter_id}}">{{ item.text }}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="dropdown-account" @click="showMenuTop = true" @mouseleave="mouseLeave">
      <span class="domain_name" v-if="accountInfo.domain_name">Phụ trách tên miền: <span>{{ accountInfo.domain_name }}</span></span>
      <span>
        {{ accountInfo.name }}
        <i class="fas fa-caret-down"></i>
      </span>
      <img src="../../../static/images/avatars/default-avatar.png">
      <ul v-if="showMenuTop">
        <router-link :to="{ name: 'account-show', params: {}}" @click.native.stop="showMenuTop = false">
          <span >Thông tin tài khoản</span>
        </router-link>
        <router-link :to="{ name: 'account-reset-pass', params: {}}" @click.native.stop="showMenuTop = false">
          <span>Đổi mật khẩu</span>
        </router-link>
        <a class="divider"></a>
        <a @click.stop.stop="confirmLogout">
          <span>Thoát tài khoản</span>
        </a>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'HeaderTop',
  data () {
    return {
      showMenuTop: false
    }
  },
  computed: {
    ...mapGetters(['breadcrumb']),
    ...mapGetters('account', ['accountInfo'])
  },
  mounted () {

  },
  methods: {
    ...mapActions('account', ['removeAccountInfo']),
    mouseLeave () {
      this.showMenuTop = false
    },
    confirmLogout () {
      this.$confirm('Xác nhận thoát tài khoản', 'Warning', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() => {
        this.removeAccountInfo()
      }).catch(() => {

      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.component-header-top {
  height: 50px;
  padding: 0px 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.dropdown-account {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  height: 100%;
  padding: 0px 3px 0px 10px;
  position: relative;
}
.dropdown-account:hover {
  background-color: #F2F2F2;
}
.dropdown-account img {
  width: 32px;
  margin-left: 8px;
}
.dropdown-account ul {
  position: absolute;
  top: 50px;
  right: 0px;
  margin: 0px;
  width: 200px;
  background-color: #fff;
  padding: 5px 0px 5px 0px;
  z-index: 1000;
  border: 1px solid #f2f2f2;
  box-shadow: 0 2px 2px rgba(0,0,0,0.05), 0 1px 0 rgba(0,0,0,0.05);
}
.dropdown-account ul a {
  list-style-type: none;
  height: 35px;
  display: flex;
  align-items: center;
  padding-left: 15px;
  text-decoration: none;
  color: #2c3e50;
}
.dropdown-account ul a:hover {
  background-color: #f2f2f2;
}
.dropdown-account ul a.divider {
  height: 1px;
  background-color: #ccc;
  margin-bottom: 5px;
}
.domain_name {
  margin-right: 10px;
  color: green;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/v1/HeaderTop.vue